import React from "react";
import Markdown from "react-markdown";
import "./mark-down-styles.css";

const MarkdownWithPoints = ({ data, tailwindStyle, components }) => {
  return (
    <div className={`markdown_list leading-relaxed ${tailwindStyle}`}>
      <Markdown components={components}>{data}</Markdown>
    </div>
  );
};

export default MarkdownWithPoints;
